

// import React, { useState } from "react";
// import { Captcha } from "./Captcha";

// const states = [
//   { id: 1, name: "Andhra Pradesh" },
//   { id: 2, name: "Arunachal Pradesh" },
//   { id: 3, name: "Assam" },
//   { id: 4, name: "Bihar" },
//   { id: 5, name: "Chhattisgarh" },
//   { id: 6, name: "Goa" },
//   { id: 7, name: "Gujarat" },
//   { id: 8, name: "Haryana" },
//   { id: 9, name: "Himachal Pradesh" },
//   { id: 10, name: "Jharkhand" },
//   { id: 11, name: "Karnataka" },
//   { id: 12, name: "Kerala" },
//   { id: 13, name: "Madhya Pradesh" },
//   { id: 14, name: "Maharashtra" },
//   { id: 15, name: "Manipur" },
//   { id: 16, name: "Meghalaya" },
//   { id: 17, name: "Mizoram" },
//   { id: 18, name: "Nagaland" },
//   { id: 19, name: "Odisha" },
//   { id: 20, name: "Punjab" },
//   { id: 21, name: "Rajasthan" },
//   { id: 22, name: "Sikkim" },
//   { id: 23, name: "Tamil Nadu" },
//   { id: 24, name: "Telangana" },
//   { id: 25, name: "Tripura" },
//   { id: 26, name: "Uttar Pradesh" },
//   { id: 27, name: "Uttarakhand" },
//   { id: 28, name: "West Bengal" },
//   { id: 29, name: "Others" },
// ];

// /**
//  * Course-to-Category mapping
//  * Used to auto-detect category when courseName is passed directly (no dropdown needed)
//  */
// const COURSE_CATEGORY_MAP = {
//   // Civil/Architecture CAD
//   "AutoCAD Civil/Arch": "Civil/Architecture CAD",
//   "AutoCAD": "Civil/Architecture CAD",
//   "Revit Architecture": "Civil/Architecture CAD",
//   "3D MAX": "Civil/Architecture CAD",
//   "Sketchup": "Civil/Architecture CAD",
//   "Lumion": "Civil/Architecture CAD",
//   "Staad Pro": "Civil/Architecture CAD",
//   "Etabs": "Civil/Architecture CAD",
//   "Revit Structure": "Civil/Architecture CAD",
//   "Civil 3D": "Civil/Architecture CAD",

//   // Mechanical CAD
//   "SolidWorks": "Mechanical CAD",
//   "Catia": "Mechanical CAD",
//   "Ansys": "Mechanical CAD",
//   "Mep": "Mechanical CAD",
//   "Fusion 360": "Mechanical CAD",
//   "Cnc": "Mechanical CAD",
//   "NX CAD": "Mechanical CAD",

//   // Electrical CAD
//   "Matlab": "Electrical CAD",
//   "Plc": "Electrical CAD",

//   // Project Management
//   "Ms Project": "Project Management CAD",
//   "Primavera": "Project Management CAD",

//   // IT Courses
//   "Full Stack Development": "IT Courses",
//   "Cyber Security": "IT Courses",
//   "C Programming": "IT Courses",
//   "Accounting": "IT Courses",
//   "Graphic Design": "IT Courses",
//   "Data Visualisation": "IT Courses",
//   "Software Testing": "IT Courses",
//   "Web Development": "IT Courses",
//   "Database Management": "IT Courses",
//   "UI & UX": "IT Courses",
//   "PhotoShop": "IT Courses",
//   "Corel Draw": "IT Courses",
//   "Canva": "IT Courses",
//   "CSS": "IT Courses",
//   "Figma": "IT Courses",
//   "HTML 5": "IT Courses",
//   "C++ Programming": "IT Courses",
//   "C# Programming": "IT Courses",
// };

// /**
//  * EnquiryForm — reusable apply form
//  *
//  * Props:
//  *   courseName    {string}  — course name sent in the email (e.g. "MATLAB", "AutoCAD Civil/Arch")
//  *                             When provided, category is auto-detected and dropdowns are hidden.
//  *   showCategory  {boolean} — show/hide category & sub-category dropdowns (default: false)
//  *                             Set true only for general inquiry pages where user picks their own course.
//  *
//  * Usage (course page — auto-detects category, hides dropdowns):
//  *   <EnquiryForm courseName="AutoCAD Civil/Arch" />
//  *
//  * Usage (general inquiry page — user selects category + course):
//  *   <EnquiryForm showCategory={true} />
//  */
// const EnquiryForm = ({ courseName = "", showCategory = false }) => {
//   const [status, setStatus] = useState("APPLY NOW");
//   const [captchaOk, setCaptchaOk] = useState(false);
//   const [errors, setErrors] = useState({});

//   const [info, setInfo] = useState({
//     name: "",
//     mobilenumber: "",
//     email: "",
//     state: "",
//     selectedOption: "",
//     subOption: "",
//   });

//   const handleChange = (event) => {
//     setInfo({ ...info, [event.target.name]: event.target.value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!captchaOk) {
//       return setErrors((p) => ({
//         ...p,
//         captcha: "Please complete the CAPTCHA verification.",
//       }));
//     }

//     setStatus("Sending...");

//     // ✅ Auto-detect category from courseName if showCategory is false
//     // This ensures the email always has category + course filled in
//     let resolvedCourseName = courseName;
//     let resolvedCategory = "";
//     let resolvedSubOption = "";

//     if (courseName && !showCategory) {
//       // Course page: courseName is fixed, auto-detect its category
//       resolvedCategory = COURSE_CATEGORY_MAP[courseName] || "General Inquiry";
//       resolvedSubOption = courseName; // course = the page course name
//     } else {
//       // General inquiry page: user selected category + sub-option from dropdowns
//       resolvedCategory = info.selectedOption;
//       resolvedSubOption = info.subOption;
//       resolvedCourseName = info.subOption || info.selectedOption || "General Inquiry";
//     }

//     try {
//       const response = await fetch(`/api/inquiry`, {
//         method: "POST",
//         headers: {
//           Accept: "application/json",
//           "Content-Type": "application/json;charset=utf-8",
//         },
//         body: JSON.stringify({
//            formType: "Applied" ,
//           name: info.name,
//           mobilenumber: info.mobilenumber,
//           email: info.email,
//           state: info.state,
//           // ✅ Always send all three — backend uses them in email
//           courseName: resolvedCourseName,
//           selectedOption: resolvedCategory,
//           subOption: resolvedSubOption,
//         }),
//       });

//       const result = await response.json();
//       alert(result.status);
//     } catch (error) {
//       console.error("Submit error:", error);
//       alert("Something went wrong. Please try again.");
//     } finally {
//       setStatus("APPLY NOW");
//       setCaptchaOk(false);
//       setInfo({
//         name: "",
//         mobilenumber: "",
//         email: "",
//         state: "",
//         selectedOption: "",
//         subOption: "",
//       });
//     }
//   };

//   const getOptions = () => {
//     switch (info.selectedOption) {
//       case "Civil/Architecture CAD":
//         return ["Autocad", "Revit Architecture", "3D MAX", "Sketchup", "Lumion", "Staad Pro", "Etabs", "Revit structure", "Civil 3d"];
//       case "Mechanical CAD":
//         return ["Autocad", "SolidWorks", "Catia", "Ansys", "Mep", "Fusion 360", "Cnc", "NX CAD"];
//       case "Electrical CAD":
//         return ["Autocad", "Matlab", "Plc"];
//       case "Project Management CAD":
//         return ["Ms Project", "Primavera"];
//       case "IT Courses":
//         return ["Full Stack Development", "Cyber Security", "C Programming", "Accounting", "Graphic Design", "Data Visualisation", "Software Testing", "Web Development", "Database Management", "UI & UX", "PhotoShop", "Corel Draw", "Canva", "CSS", "Figma", "HTML 5", "C++ Programming", "C# Programming"];
//       default:
//         return [];
//     }
//   };

//   return (
//     <div id="signup-form" style={{ padding: "20px" }}>
//       <form id="applyOnlyEnqury" onSubmit={handleSubmit}>
//         <input type="hidden" name="valid" value="false" />

//         {/* Name */}
//         <div className="form-group">
//           <label className="control-label">Name:</label>
//           <input
//             type="text"
//             id="name"
//             name="name"
//             className="form-control"
//             placeholder="Enter Your Name"
//             required
//             pattern="[a-zA-Z\s]+"
//             title="Please enter only alphabets"
//             value={info.name}
//             onChange={handleChange}
//           />
//         </div>

//         {/* Email */}
//         <div className="form-group">
//           <label className="control-label">Email:</label>
//           <input
//             type="text"
//             id="email"
//             name="email"
//             className="form-control"
//             placeholder="Enter Your Email Address"
//             required
//             pattern="[^\s@]+@[^\s@]+\.[^\s@]+"
//             title="Please enter a valid email address"
//             value={info.email}
//             onChange={handleChange}
//           />
//         </div>

//         {/* Mobile */}
//         <div className="form-group">
//           <label className="control-label">Mobile:</label>
//           <input
//             type="text"
//             id="mobilenumber"
//             name="mobilenumber"
//             className="form-control"
//             placeholder="Enter Your mobile number"
//             required
//             pattern="\d{10}"
//             title="Please enter a 10-digit phone number"
//             value={info.mobilenumber}
//             onChange={handleChange}
//           />
//         </div>

//         {/* State */}
//         <div className="form-group mb-0">
//           <div className="form-row">
//             <div className="form-group col-6">
//               <label className="control-label">State</label>
//               <select
//                 id="state"
//                 name="state"
//                 className="form-control"
//                 required
//                 value={info.state}
//                 onChange={handleChange}
//               >
//                 <option value="">SELECT STATE</option>
//                 {states.map((s) => (
//                   <option key={s.id} value={s.name}>
//                     {s.name}
//                   </option>
//                 ))}
//               </select>
//             </div>
//           </div>
//         </div>

//         {/*
//           ✅ Category & Sub-category dropdowns:
//           - HIDDEN on course pages (showCategory=false) — category is auto-detected from courseName
//           - SHOWN on general inquiry pages (showCategory=true) — user picks their own
//         */}
//         {showCategory && (
//           <>
//             <div className="form-group">
//               <label className="control-label">Category</label>
//               <select
//                 className="form-control"
//                 value={info.selectedOption || ""}
//                 name="selectedOption"
//                 required
//                 onChange={handleChange}
//               >
//                 <option value="">Select Category</option>
//                 <option value="Civil/Architecture CAD">Civil/Architecture</option>
//                 <option value="Mechanical CAD">Mechanical</option>
//                 <option value="Electrical CAD">Electrical</option>
//                 <option value="Project Management CAD">Project Management</option>
//                 <option value="IT Courses">IT Courses</option>
//               </select>
//             </div>

//             {info.selectedOption && (
//               <div className="form-group">
//                 <label className="control-label">Course</label>
//                 <select
//                   className="form-control"
//                   required
//                   name="subOption"
//                   value={info.subOption}
//                   onChange={handleChange}
//                 >
//                   <option value="">Select {info.selectedOption}</option>
//                   {getOptions().map((subOption) => (
//                     <option key={subOption} value={subOption}>
//                       {subOption}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             )}
//           </>
//         )}

//         {/* CAPTCHA */}
//         <div className="form-group">
//           <Captcha
//             onVerified={(ok) => {
//               setCaptchaOk(ok);
//               setErrors((p) => ({ ...p, captcha: "" }));
//             }}
//           />
//           {errors.captcha && (
//             <span className="text-danger" style={{ fontSize: "12px" }}>
//               {errors.captcha}
//             </span>
//           )}
//         </div>

//         {/* Submit */}
//         <div
//           className="form-group mb-0"
//           style={{ marginLeft: "130px", paddingBottom: "30px" }}
//         >
//           <button
//             type="submit"
//             id="submitEnqury"
//             name="submitEnqury"
//             className="btn btn-primary contest_register_now"
//             disabled={status === "Sending..."}
//           >
//             {status}
//           </button>
//         </div>
//       </form>
//     </div>
//   );
// };

// export default EnquiryForm;


import React, { useState } from "react";
import { Captcha } from "./Captcha";

const states = [
  { id: 1, name: "Andhra Pradesh" },
  { id: 2, name: "Arunachal Pradesh" },
  { id: 3, name: "Assam" },
  { id: 4, name: "Bihar" },
  { id: 5, name: "Chhattisgarh" },
  { id: 6, name: "Goa" },
  { id: 7, name: "Gujarat" },
  { id: 8, name: "Haryana" },
  { id: 9, name: "Himachal Pradesh" },
  { id: 10, name: "Jharkhand" },
  { id: 11, name: "Karnataka" },
  { id: 12, name: "Kerala" },
  { id: 13, name: "Madhya Pradesh" },
  { id: 14, name: "Maharashtra" },
  { id: 15, name: "Manipur" },
  { id: 16, name: "Meghalaya" },
  { id: 17, name: "Mizoram" },
  { id: 18, name: "Nagaland" },
  { id: 19, name: "Odisha" },
  { id: 20, name: "Punjab" },
  { id: 21, name: "Rajasthan" },
  { id: 22, name: "Sikkim" },
  { id: 23, name: "Tamil Nadu" },
  { id: 24, name: "Telangana" },
  { id: 25, name: "Tripura" },
  { id: 26, name: "Uttar Pradesh" },
  { id: 27, name: "Uttarakhand" },
  { id: 28, name: "West Bengal" },
  { id: 29, name: "Others" },
];

const COURSE_CATEGORY_MAP = {
  "AutoCAD Civil/Arch": "Civil/Architecture CAD",
  "AutoCAD": "Civil/Architecture CAD",
  "Revit Architecture": "Civil/Architecture CAD",
  "3D MAX": "Civil/Architecture CAD",
  "Sketchup": "Civil/Architecture CAD",
  "Lumion": "Civil/Architecture CAD",
  "Staad Pro": "Civil/Architecture CAD",
  "Etabs": "Civil/Architecture CAD",
  "Revit Structure": "Civil/Architecture CAD",
  "Civil 3D": "Civil/Architecture CAD",
  "SolidWorks": "Mechanical CAD",
  "Catia": "Mechanical CAD",
  "Ansys": "Mechanical CAD",
  "Mep": "Mechanical CAD",
  "Fusion 360": "Mechanical CAD",
  "Cnc": "Mechanical CAD",
  "NX CAD": "Mechanical CAD",
  "Matlab": "Electrical CAD",
  "Plc": "Electrical CAD",
  "Ms Project": "Project Management CAD",
  "Primavera": "Project Management CAD",
  "Full Stack Development": "IT Courses",
  "Cyber Security": "IT Courses",
  "C Programming": "IT Courses",
  "Accounting": "IT Courses",
  "Graphic Design": "IT Courses",
  "Data Visualisation": "IT Courses",
  "Software Testing": "IT Courses",
  "Web Development": "IT Courses",
  "Database Management": "IT Courses",
  "UI & UX": "IT Courses",
  "PhotoShop": "IT Courses",
  "Corel Draw": "IT Courses",
  "Canva": "IT Courses",
  "CSS": "IT Courses",
  "Figma": "IT Courses",
  "HTML 5": "IT Courses",
  "C++ Programming": "IT Courses",
  "C# Programming": "IT Courses",
};

const EnquiryForm = ({ courseName = "", showCategory = false }) => {
  const [status, setStatus] = useState("APPLY NOW");
  const [captchaOk, setCaptchaOk] = useState(false);
  const [errors, setErrors] = useState({});

  const [info, setInfo] = useState({
    name: "",
    mobilenumber: "",
    email: "",
    state: "",
    selectedOption: "",
    subOption: "",
  });

  const handleChange = (event) => {
    setInfo({ ...info, [event.target.name]: event.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!captchaOk) {
      return setErrors((p) => ({
        ...p,
        captcha: "Please complete the CAPTCHA verification.",
      }));
    }

    setStatus("Sending...");

    let resolvedCourseName = courseName;
    let resolvedCategory = "";
    let resolvedSubOption = "";

    if (courseName && !showCategory) {
      resolvedCategory = COURSE_CATEGORY_MAP[courseName] || "General Inquiry";
      resolvedSubOption = courseName;
    } else {
      resolvedCategory = info.selectedOption;
      resolvedSubOption = info.subOption;
      resolvedCourseName = info.subOption || info.selectedOption || "General Inquiry";
    }

    try {
      const response = await fetch(`/api/inquiry`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=utf-8",
        },
        body: JSON.stringify({
          formType: "Applied",
          name: info.name,
          mobilenumber: info.mobilenumber,
          email: info.email,
          state: info.state,
          courseName: resolvedCourseName,
          selectedOption: resolvedCategory,
          subOption: resolvedSubOption,
        }),
      });

      const result = await response.json();
      alert(result.status);
    } catch (error) {
      console.error("Submit error:", error);
      alert("Something went wrong. Please try again.");
    } finally {
      setStatus("APPLY NOW");
      setCaptchaOk(false);
      setInfo({
        name: "",
        mobilenumber: "",
        email: "",
        state: "",
        selectedOption: "",
        subOption: "",
      });
    }
  };

  const getOptions = () => {
    switch (info.selectedOption) {
      case "Civil/Architecture CAD":
        return ["Autocad", "Revit Architecture", "3D MAX", "Sketchup", "Lumion", "Staad Pro", "Etabs", "Revit structure", "Civil 3d"];
      case "Mechanical CAD":
        return ["Autocad", "SolidWorks", "Catia", "Ansys", "Mep", "Fusion 360", "Cnc", "NX CAD"];
      case "Electrical CAD":
        return ["Autocad", "Matlab", "Plc"];
      case "Project Management CAD":
        return ["Ms Project", "Primavera"];
      case "IT Courses":
        return ["Full Stack Development", "Cyber Security", "C Programming", "Accounting", "Graphic Design", "Data Visualisation", "Software Testing", "Web Development", "Database Management", "UI & UX", "PhotoShop", "Corel Draw", "Canva", "CSS", "Figma", "HTML 5", "C++ Programming", "C# Programming"];
      default:
        return [];
    }
  };

  return (
    <>
      <style>{`
        #signup-form {
          padding: 12px 14px;
          width: 100%;
          box-sizing: border-box;
        }

        #signup-form *,
        #signup-form *::before,
        #signup-form *::after {
          box-sizing: border-box;
        }

        #signup-form .eq-group {
          margin-bottom: 8px;
          width: 100%;
        }

        #signup-form .eq-label {
          display: block;
          font-size: 12px;
          font-weight: 600;
          margin-bottom: 2px;
          color: inherit;
        }

        /* Override Bootstrap + any other styles forcing fixed width */
        #signup-form input.eq-field,
        #signup-form select.eq-field {
          display: block !important;
          width: 100% !important;
          min-width: 0 !important;
          max-width: 100% !important;
          height: 32px !important;
          font-size: 12px !important;
          padding: 4px 8px !important;
          border: 1px solid #ced4da !important;
          border-radius: 4px !important;
          background-color: #fff !important;
          color: #495057 !important;
          line-height: 1.4 !important;
          box-shadow: none !important;
          appearance: auto;
          -webkit-appearance: auto;
        }

        #signup-form input.eq-field:focus,
        #signup-form select.eq-field:focus {
          border-color: #80bdff !important;
          box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25) !important;
          outline: none !important;
        }

        #signup-form .eq-captcha-wrap {
          width: 100%;
          overflow: hidden;
          margin-bottom: 8px;
          margin-top: 6px;
        }

        /* Force captcha children to stay within bounds */
        #signup-form .eq-captcha-wrap > * {
          max-width: 100% !important;
          overflow: hidden !important;
        }

        #signup-form .eq-error {
          display: block;
          font-size: 11px;
          color: #dc3545;
          margin-top: 2px;
        }

        #signup-form .eq-submit-wrap {
          text-align: center;
          padding-bottom: 10px;
          width: 100%;
        }

        #signup-form .eq-submit-btn {
          font-size: 13px !important;
          padding: 6px 24px !important;
          height: 34px !important;
          cursor: pointer;
        }
      `}</style>

      <div id="signup-form">
        <form id="applyOnlyEnqury" onSubmit={handleSubmit}>
          <input type="hidden" name="valid" value="false" />

          {/* Name */}
          <div className="eq-group">
            <label className="eq-label">Name:</label>
            <input
              type="text"
              id="name"
              name="name"
              className="eq-field"
              placeholder="Enter Your Name"
              required
              pattern="[a-zA-Z\s]+"
              title="Please enter only alphabets"
              value={info.name}
              onChange={handleChange}
            />
          </div>

          {/* Email */}
          <div className="eq-group">
            <label className="eq-label">Email:</label>
            <input
              type="text"
              id="email"
              name="email"
              className="eq-field"
              placeholder="Enter Your Email Address"
              required
              pattern="[^\s@]+@[^\s@]+\.[^\s@]+"
              title="Please enter a valid email address"
              value={info.email}
              onChange={handleChange}
            />
          </div>

          {/* Mobile */}
          <div className="eq-group">
            <label className="eq-label">Mobile:</label>
            <input
              type="text"
              id="mobilenumber"
              name="mobilenumber"
              className="eq-field"
              placeholder="Enter Your mobile number"
              required
              pattern="\d{10}"
              title="Please enter a 10-digit phone number"
              value={info.mobilenumber}
              onChange={handleChange}
            />
          </div>

          {/* State */}
          <div className="eq-group">
            <label className="eq-label">State</label>
            <select
              id="state"
              name="state"
              className="eq-field"
              required
              value={info.state}
              onChange={handleChange}
            >
              <option value="">SELECT STATE</option>
              {states.map((s) => (
                <option key={s.id} value={s.name}>
                  {s.name}
                </option>
              ))}
            </select>
          </div>

          {/* Category & Sub-category (general inquiry only) */}
          {showCategory && (
            <>
              <div className="eq-group">
                <label className="eq-label">Category</label>
                <select
                  className="eq-field"
                  value={info.selectedOption || ""}
                  name="selectedOption"
                  required
                  onChange={handleChange}
                >
                  <option value="">Select Category</option>
                  <option value="Civil/Architecture CAD">Civil/Architecture</option>
                  <option value="Mechanical CAD">Mechanical</option>
                  <option value="Electrical CAD">Electrical</option>
                  <option value="Project Management CAD">Project Management</option>
                  <option value="IT Courses">IT Courses</option>
                </select>
              </div>

              {info.selectedOption && (
                <div className="eq-group">
                  <label className="eq-label">Course</label>
                  <select
                    className="eq-field"
                    required
                    name="subOption"
                    value={info.subOption}
                    onChange={handleChange}
                  >
                    <option value="">Select {info.selectedOption}</option>
                    {getOptions().map((subOption) => (
                      <option key={subOption} value={subOption}>
                        {subOption}
                      </option>
                    ))}
                  </select>
                </div>
              )}
            </>
          )}

          {/* CAPTCHA */}
          <div className="eq-captcha-wrap">
            <Captcha
              onVerified={(ok) => {
                setCaptchaOk(ok);
                setErrors((p) => ({ ...p, captcha: "" }));
              }}
            />
            {errors.captcha && (
              <span className="eq-error">{errors.captcha}</span>
            )}
          </div>

          {/* Submit */}
          <div className="eq-submit-wrap">
            <button
              type="submit"
              id="submitEnqury"
              name="submitEnqury"
              className="btn btn-primary contest_register_now eq-submit-btn"
              disabled={status === "Sending..."}
            >
              {status}
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default EnquiryForm;